import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'
import useFetchAsJson from '@eig-builder/core-utils/hooks/useFetchAsJson'

import LinkText from 'core/components/link-text'
import { getCrmApiOptions } from '../../../modules/crm/helpers/fetch-options-helper'

const StyledLink = styled.a`
  text-decoration: none;
`

let SSO_WINDOW

const InsightsLink = ({ account, dataElementSuffix, siteId }) => {
  const [ssoReq, createSso] = useFetchAsJson()

  useEffect(() => {
    if (ssoReq.isSuccess) {
      if (ssoReq.data && ssoReq.data.url) {
        SSO_WINDOW && SSO_WINDOW.location.replace(ssoReq.data.url)
      }
    }

    if (ssoReq.isError) {
      SSO_WINDOW.close()
      SSO_WINDOW = undefined
    }
  }, [ssoReq.isSuccess, ssoReq.isError])

  const handleLinkClick = () => {
    SSO_WINDOW = window.open('/testing-tools/loading', '_blank')

    createSso(getCrmApiOptions(account, `/v1.0/sites/insights/${siteId}`))
  }

  if (!account.id || !account.partnerId || !siteId) {
    return null
  }

  return <StyledLink
    dataElementLocation={DataElementLocations.BODY}
    dataElementLabel={`cst--sites-tab--insights-link--${dataElementSuffix}`}
    dataElementId={`cst--sites-tab--insights-link--${dataElementSuffix}`}
    onClick={handleLinkClick}
>
    <LinkText>
      Insights
    </LinkText>
  </StyledLink>
}

InsightsLink.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    partnerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  dataElementSuffix: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default InsightsLink
